export default {"src":"/_next/static/media/hardscaping.f5ec92a0.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};